import PropTypes from "prop-types";
import AlertComponent from "@material-ui/lab/Alert";

import { useStyles } from "./Alert.styles";

export const Alert = ({ message, severity, icon, onClose, open }, props) => {
  const classes = useStyles();

  return (
    open && (
      <AlertComponent
        role="alert"
        className={classes.root}
        severity={severity}
        icon={icon}
        onClose={onClose}
        {...props}
      >
        {message}
      </AlertComponent>
    )
  );
};

Alert.displayName = "Alert";

Alert.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  severity: PropTypes.string,
  icon: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
Alert.defaultProps = {
  className: "",
  message: "",
  severity: "",
  icon: null,
  onClose: null,
  open: false,
};
